import React from 'react'
import { Document, Key, Smallarw, TwoFactor } from '../../../assests/ExportImageIcon'
import './privacySecurity.css'

const SECURITY_MENU = [
    // { icon: TwoFactor, title: 'Two Factor Authentication', subtitle: 'Add an extra layer of security' },
    { icon: Document, title: 'KYC Documents', subtitle: 'Manage your identity documents', key: 'kyc-document' },
    // { icon: 'shield', title: 'Data & Privacy', subtitle: 'Manage your data and privacy preferences', key: 'data-privacy' },
]

const SECURITY_TIPS = [
    'Use a strong, unique password',
    'Enable two-factor authentication',
    "Don't share your account credentials",
    'Review login activity regularly',
]

const ShieldIcon = () => (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
        <path d="M10 1.66667L16.6667 4.16667V9.16667C16.6667 13.0917 13.8517 16.7417 10 18.3333C6.14833 16.7417 3.33333 13.0917 3.33333 9.16667V4.16667L10 1.66667Z" stroke="#026D4D" strokeWidth="1.5" strokeLinejoin="round" />
    </svg>
)

const PrivacySecurity = ({ onNavigate }) => {
    return (
        <div className='privacySecurity'>
            <div className='privacySecurity__title'>Your account is secure</div>
            <div className='privacySecurity__subtitle'>Last security check: 2 hours ago</div>

            <div className='bsSectionTitle mt-4'>Linked Wallets</div>
            <div className='bgWhite commonBorder borderRadius20'>
                {SECURITY_MENU.map((item, index) => (
                    <div
                        className='securityMenuItem'
                        key={index}
                        onClick={item.key ? () => onNavigate(item.key) : undefined}
                    >
                        <span className='securityMenuItem__icon'>
                            {item.icon === 'shield' ? <ShieldIcon /> : <img src={item.icon} alt="" />}
                        </span>
                        <div className='securityMenuItem__info'>
                            <div className='securityMenuItem__title'>{item.title}</div>
                            <div className='securityMenuItem__subtitle'>{item.subtitle}</div>
                        </div>
                        <img src={Smallarw} alt="" className='securityMenuItem__arrow' />
                    </div>
                ))}
            </div>

            <div className='bsSectionTitle mt-4'>Security Tips</div>
            <div className='bsBox'>
                <ul className='bsInfoList'>
                    {SECURITY_TIPS.map((tip, index) => (
                        <li key={index}>{tip}</li>
                    ))}
                </ul>
            </div>
        </div>
    )
}

export default PrivacySecurity
